import { History } from 'history';

export function replaceSearchParamsWith(
  history: History,
  cb: (searchParams: URLSearchParams) => unknown,
) {
  const searchParams = new URLSearchParams(history.location.search);

  cb(searchParams);

  const search = searchParams.toString();

  history.replace({
    ...history.location,
    search: search ? `?${search}` : '',
  });
}
